<div class="custom-box" *ngIf="isDataAvailable()">
    <section class="blue-theme" *ngIf="color === 'pur'">
        <!--first row-->
        <div class=" scroll row grid">
            <div class="col-lg-11  gst-section mb3  ">
                <div class="col-xs-12 col-md-6 col-lg-4 card solution_card">
                    <div class="hover_color_bubble"></div>
                    <div class="">
                        <span *ngFor="let taxLeg of taxLegislationList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="taxLeg.contentType?.titleEn"
                                [textHi]="taxLeg.contentType?.titleHi"></cbic-static-text>
                        </span>
                    </div>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let taxLeg of taxLegislationList">
                            <a href="{{taxLeg.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="taxLeg.titleEn" [linkTextHi]="taxLeg.titleHi"
                                [linkEn]="taxLeg.path" [linkHi]="taxLeg.path"></cbic-link>
                        </li>
                    </ul>

                </div>
                <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
                        <span *ngFor="let onlineService of onlineServiceList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="onlineService.contentType?.titleEn"
                                [textHi]="onlineService.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="">
                        <li *ngFor="let onlineService of onlineServiceList">
                            <a href="{{onlineService.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="onlineService.titleEn" [linkTextHi]="onlineService.titleHi"
                                [linkEn]="onlineService.path" [linkHi]="onlineService.path"></cbic-link>
                        </li>
                    </ul>
                </div>

                <div class="col-xs-12 col-md-6 col-lg-4 card solution_card">
                        <span *ngFor="let tariffData of tariffDataList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="tariffData.contentType?.titleEn"
                                [textHi]="tariffData.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="">
                        <li *ngFor="let tariffData of tariffDataList">
                            <a href="{{tariffData.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="tariffData.titleEn" [linkTextHi]="tariffData.titleHi"
                                [linkEn]="tariffData.path" [linkHi]="tariffData.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-11  ce-section">
                <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
                        <span *ngFor="let legacyData of legacyDataList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="legacyData.contentType?.titleEn"
                                [textHi]="legacyData.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="cus tom-scroll-bar">
                        <li *ngFor="let legacyData of legacyDataList">
                            <a href="{{legacyData.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="legacyData.titleEn" [linkTextHi]="legacyData.titleHi"
                                [linkEn]="legacyData.path" [linkHi]="legacyData.path"></cbic-link>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
                        <span *ngFor="let caseData of caseDataList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="caseData.contentType?.titleEn"
                                [textHi]="caseData.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let caseData of caseDataList">
                            <a href="{{caseData.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="caseData.titleEn" [linkTextHi]="caseData.titleHi"
                                [linkEn]="caseData.path" [linkHi]="caseData.path"></cbic-link>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card">
                        <span *ngFor="let otherData of otherDataList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="otherData.contentType?.titleEn"
                                [textHi]="otherData.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let otherData of otherDataList">
                            <a href="{{otherData.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="otherData.titleEn" [linkTextHi]="otherData.titleHi"
                                [linkEn]="otherData.path" [linkHi]="otherData.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <section class="gst-section-black" *ngIf="color === 'bule'">
        <div class=" row grid">
            <div class="col-lg-11  ce-section mb3  ">
                <div class="col-xs-12 col-md-6 col-lg-4 card solution_card">
                        <span *ngFor="let taxLeg of taxLegislationList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="taxLeg.contentType?.titleEn"
                                [textHi]="taxLeg.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let taxLeg of taxLegislationList">
                            <a href="{{taxLeg.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="taxLeg.titleEn" [linkTextHi]="taxLeg.titleHi"
                                [linkEn]="taxLeg.path" [linkHi]="taxLeg.path"></cbic-link>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
                        <span *ngFor="let onlineService of onlineServiceList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="onlineService.contentType?.titleEn"
                                [textHi]="onlineService.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="">
                        <li *ngFor="let onlineService of onlineServiceList">
                            <a href="{{onlineService.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="onlineService.titleEn" [linkTextHi]="onlineService.titleHi"
                                [linkEn]="onlineService.path" [linkHi]="onlineService.path"></cbic-link>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-12 col-md-6 col-lg-4 card solution_card">
                        <span *ngFor="let tariffData of tariffDataList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="tariffData.contentType?.titleEn"
                                [textHi]="tariffData.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="">
                        <li *ngFor="let tariffData of tariffDataList">
                            <a href="{{tariffData.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="tariffData.titleEn" [linkTextHi]="tariffData.titleHi"
                                [linkEn]="tariffData.path" [linkHi]="tariffData.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-11  ce-section">
                <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
                        <span *ngFor="let legacyData of legacyDataList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="legacyData.contentType?.titleEn"
                                [textHi]="legacyData.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="cus tom-scroll-bar">
                        <li *ngFor="let legacyData of legacyDataList">
                            <a href="{{legacyData.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="legacyData.titleEn" [linkTextHi]="legacyData.titleHi"
                                [linkEn]="legacyData.path" [linkHi]="legacyData.path"></cbic-link>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
                        <span *ngFor="let caseData of caseDataList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="caseData.contentType?.titleEn"
                                [textHi]="caseData.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let caseData of caseDataList">
                            <a href="{{caseData.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="caseData.titleEn" [linkTextHi]="caseData.titleHi"
                                [linkEn]="caseData.path" [linkHi]="caseData.path"></cbic-link>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card">
                        <span *ngFor="let otherData of otherDataList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="otherData.contentType?.titleEn"
                                [textHi]="otherData.contentType?.titleHi"></cbic-static-text>
                        </span>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let otherData of otherDataList">
                            <a href="{{otherData.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="otherData.titleEn" [linkTextHi]="otherData.titleHi"
                                [linkEn]="otherData.path" [linkHi]="otherData.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section> 
</div>